export enum ContainerId {
  RootContainer = 'RootContainer',
  TooltipsContainer = 'TooltipsContainer',
  ChapterName = 'ChapterName',
  ShopifyTitle = 'ShopifyTitle',
  ShopifyDescription = 'ShopifyDescription',
  UserName = 'UserName',
}
